import { useEffect } from 'react'

interface IProps {
  enabled: boolean
  onIntersect: () => void
  // root?: React.MutableRefObject<HTMLDivElement | null>
  rootMargin?: string
  target: React.MutableRefObject<HTMLDivElement | null>
  threshold?: number
}

export default function useIntersectionObserver({
  enabled = true,
  onIntersect,
  // root,
  rootMargin = '0px',
  target,
  threshold = 0.1,
}: IProps) {
  useEffect(() => {
    if (!enabled) {
      return
    }
    const observer = new IntersectionObserver(
      (entries) =>
        entries.forEach((entry) => {
          entry.isIntersecting && onIntersect()
        }),
      {
        // root: root && root.current,
        rootMargin,
        threshold,
      },
    )

    const el = target && target.current

    if (!el) {
      return
    }

    observer.observe(el)

    return () => {
      observer.unobserve(el)
    }
  }, [target.current, enabled])
}
